import { RouteRecordRaw } from 'vue-router'

export const plansRoute: RouteRecordRaw = {
  name: 'planos',
  path: '/planos',
  component: () => import('@/features/plans/pages/PlansPage.vue'),
}
